<div class="pace-barcode-scanner">
    <div class="d-flex justify-content-end">
        @if (devices.length > 1) {
            <div class="btn-group d-flex mw-100" role="group" [attr.aria-label]="chooseWebcamLabel()">
                @for (device of devices; track device.deviceId) {
                    <button
                        type="button"
                        class="btn btn-primary btn-sm text-truncate flex-fill"
                        [class.active]="currentDeviceId === device.deviceId"
                        (click)="switchCamera(device.deviceId)"
                        [title]="device.label"
                    >
                        {{ device.label }}
                    </button>
                }
            </div>
        }
    </div>

    <div
        class="pace-barcode-scanner__recognised d-flex flex-wrap gap-1 justify-content-lg-start justify-content-center"
    >
        @for (rec of recognised | keyvalue; track rec.key) {
            <div class="col-12 col-lg-auto">
                <button
                    type="button"
                    class="btn btn-primary w-100"
                    (click)="selectBarcode(rec.value)"
                    [disabled]="!rec.value.matchesPattern"
                    [tooltip]="rec.value.matchesPattern ? '' : mismatchTooltip()"
                    [attr.aria-label]="pickLabel()"
                >
                    {{ rec.value.displayString }}
                    <span class="badge bg-info">{{ rec.value.readResult.format }}</span>
                </button>
            </div>
        }
    </div>

    <div class="position-relative my-2">
        <video #barcodeVideo autoplay playsinline="playsinline" class="w-100"></video>

        @if (displayMessages.length > 0) {
            <ul class="position-absolute top-0 start-0 m-1 bg-light opacity-75 list-group">
                @for (message of displayMessages; track message) {
                    <li class="list-group-item">{{ message }}</li>
                }
            </ul>
        }
        <button
            type="button"
            class="btn btn-secondary bg-white position-absolute top-0 end-0 my-2"
            (click)="refocus()"
            [tooltip]="'Click to restart the stream.'"
            [attr.aria-label]="restartStreamLabel()"
        >
            <fa-icon [icon]="refocusIcon" class="pe-1"></fa-icon>
        </button>
        @if (pattern()) {
            <button
                type="button"
                class="btn btn-secondary bg-white position-absolute bottom-0 end-0 my-2"
                (click)="toggleShowPattern()"
                [tooltip]="togglePatternLabel()"
                [attr.aria-label]="togglePatternLabel()"
            >
                @if (showPattern) {
                    Expected pattern: <code>{{ pattern() }}</code>
                } @else {
                    <fa-icon [icon]="patternIcon"></fa-icon>
                }
            </button>
        }
        @if (minHeight > 10) {
            <div
                class="position-absolute top-0 start-0 w-100 text-center d-flex flex-column justify-content-center"
                [ngStyle]="{ 'min-height': minHeight + 'px' }"
            >
                Stream is restarting....
                <progressbar [value]="100" [animate]="true"></progressbar>
            </div>
        } @else {
            <div class="pace-barcode-scanner__aim-hair"></div>
        }
    </div>
</div>
